/**
 * @function makeGroupSelData
 * @param { Array } apps
 * @param { Array } groups
 * @returns { Array }
 */
function makeGroupSelData(apps, groups) {
	let roleGroups = [];

	for (let i = 0; i < apps.length; i++) {
		for (let j = 0; j < groups.length; j++) {
			if (apps[i].id === groups[j].appId) {
				let roleGroup = {
					id: groups[j].id,
					name: groups[j].name,
					appId: groups[j].appId,
					appName: apps[i].name,
				};
				roleGroups.push(roleGroup);
			}
		}
	}

	return roleGroups;
}

export default makeGroupSelData;
